module.exports = __webpack_public_path__ + "static/media/NogueiraFlorida.e8d7e76a.png";